/**
 * @generated SignedSource<<fcc6b1f79fe99c9832a5dfe4ada221eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type luminaUserProfilePreviewRelay_smarts$data = {
  readonly recommendedUser: ReadonlyArray<{
    readonly user: {
      readonly accountId: string;
      readonly email?: string | null | undefined;
      readonly extendedProfile?: {
        readonly jobTitle: string | null | undefined;
      } | null | undefined;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "luminaUserProfilePreviewRelay_smarts";
};
export type luminaUserProfilePreviewRelay_smarts$key = {
  readonly " $data"?: luminaUserProfilePreviewRelay_smarts$data;
  readonly " $fragmentSpreads": FragmentRefs<"luminaUserProfilePreviewRelay_smarts">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "recommendationsQuery"
    }
  ],
  "kind": "Fragment",
  "name": "luminaUserProfilePreviewRelay_smarts",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "recommendationsQuery",
          "variableName": "recommendationsQuery"
        }
      ],
      "concreteType": "SmartsRecommendedUser",
      "kind": "LinkedField",
      "name": "recommendedUser",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountId"
            },
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "picture"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                },
                {
                  "concreteType": "AtlassianAccountUserExtendedProfile",
                  "kind": "LinkedField",
                  "name": "extendedProfile",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "jobTitle"
                    }
                  ]
                }
              ],
              "type": "AtlassianAccountUser"
            }
          ]
        }
      ]
    }
  ],
  "type": "SmartsQueryApi"
};

(node as any).hash = "cffa7975636a11ba7f7cf18a2c5288ae";

export default node;
